import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import FloatTooltip from 'ui-library/floating-ui/Tooltip';

export function MethodEditorTabSavingButtons({
  isEditingMethodTab,
  anyErrors,
  errorText,
  areTablesStillLoading,
  handleOnCancel,
  handleOnSubmit,
  handleOnEdit,
}: {
  isEditingMethodTab: boolean;
  anyErrors: boolean;
  errorText: string;
  areTablesStillLoading: boolean;
  handleOnCancel: () => void;
  handleOnSubmit: () => void;
  handleOnEdit: () => void;
}): JSX.Element {
  return isEditingMethodTab ? (
    <div>
      <Button
        className={css(styles.detailsSaveButton)}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MINI}
        text="Cancel"
        onClick={handleOnCancel}
        disabled={false}
        dataTestAttrs={{component: 'MethodEditorTabSavingButtons', element: 'cancel'}}
      />
      <FloatTooltip text={errorText} isDisabled={!anyErrors}>
        <Button
          className={css(styles.detailsSaveButton)}
          buttonStyle={ButtonStyle.PRIMARY}
          size={ButtonSize.MINI}
          text="Save"
          onClick={handleOnSubmit}
          disabled={anyErrors}
          dataTestAttrs={{component: 'MethodEditorTabSavingButtons', element: 'submit'}}
        />
      </FloatTooltip>
    </div>
  ) : (
    <FloatTooltip text="Please wait for tables to load" isDisabled={!areTablesStillLoading}>
      <Button
        className={css(styles.detailsSaveButton)}
        icon="edit"
        buttonStyle={ButtonStyle.PRIMARY}
        size={ButtonSize.MINI}
        text="Edit"
        onClick={handleOnEdit}
        disabled={areTablesStillLoading}
        dataTestAttrs={{component: 'MethodEditorTabSavingButtons', element: 'edit'}}
      />
    </FloatTooltip>
  );
}

export const methodEditorHorizontalMargin = '25px';
export const methodEditorVerticalMargin = '16px';
export const styles = StyleSheet.create({
  detailsSaveButton: {
    flex: '0 0 auto',
    marginRight: '10px',
  },
  // Used in tabs that show the save/cancel buttons
  detailsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: methodEditorHorizontalMargin,
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  detailsContent: {
    flex: '1 1 0',
    minHeight: '250px',
  },
  detailsContentScrollContainer: {
    overflowY: 'scroll',
    height: '100%',
    // Padding used instead of margins so that scrollbars render correctly
    paddingBottom: methodEditorVerticalMargin,
    paddingRight: methodEditorHorizontalMargin,
  },
});
